import { useSearchParams } from "react-router-dom"
import { REPORTING_ENTITY_LABELS, type ReportingEntity } from "@pishgam/contracts"

import { cn } from "@/lib/utils"

const ENTITIES: ReportingEntity[] = ["pishgam", "faraz"]

/** Pishgam and Faraz report separately; the choice lives in the URL so views can be shared. */
export function useEntity(): [ReportingEntity, (entity: ReportingEntity) => void] {
  const [params, setParams] = useSearchParams()
  const entity: ReportingEntity = params.get("entity") === "faraz" ? "faraz" : "pishgam"
  const setEntity = (next: ReportingEntity) => {
    setParams((current) => {
      const copy = new URLSearchParams(current)
      if (next === "pishgam") copy.delete("entity")
      else copy.set("entity", next)
      return copy
    }, { replace: true })
  }
  return [entity, setEntity]
}

export function EntitySwitch({ value, onChange }: { value: ReportingEntity; onChange: (entity: ReportingEntity) => void }) {
  return (
    <div role="radiogroup" aria-label="شرکت" className="inline-flex rounded-lg border bg-muted p-1">
      {ENTITIES.map((entity) => (
        <button
          key={entity}
          type="button"
          role="radio"
          aria-checked={value === entity}
          onClick={() => onChange(entity)}
          className={cn(
            "rounded-md px-4 py-1.5 text-sm font-medium transition-colors focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none",
            value === entity ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground",
          )}
        >
          {REPORTING_ENTITY_LABELS[entity]}
        </button>
      ))}
    </div>
  )
}
